import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import Skeleton from '../Skeleton';

const Container = styled.div`
  ${tw`mx-auto w-full max-w-3xl p-6 flex flex-col`}
`;

const Header = styled.div`
  ${tw`flex items-center justify-between border-b border-border-default pb-4 mb-8`}
`;

const HeaderLeft = styled.div`
  ${tw`flex flex-col`}
`;

const CarPreview = styled.div`
  ${tw`flex items-center gap-4`}
`;

const TripSection = styled.div`
  ${tw`mb-8`}
`;

const TripDates = styled.div`
  ${tw`flex items-center gap-6 mb-6`}
`;

const DateBlock = styled.div`
  ${tw`flex flex-col`}
`;

const ArrowSkeleton = styled(Skeleton)`
  ${tw`w-6 h-6`}
`;

const ButtonContainer = styled.div`
  ${tw`flex gap-1 justify-center w-full flex-col mt-4`}
`;

const LocationSection = styled.div`
  ${tw`mb-6`}
`;

const InfoSection = styled.div`
  ${tw`mb-6`}
`;

const SectionSkeleton = styled(Skeleton)`
  ${tw`w-32 h-5 mb-2`}
`;

const InfoTextSkeleton = styled(Skeleton)`
  ${tw`w-full h-6 mb-2`}
`;

const SubTextSkeleton = styled(Skeleton)`
  ${tw`w-3/4 h-4 mb-4`}
`;

const BookingDetailsSkeleton: React.FC = () => {
  return (
    <Container>
      <Header>
        <HeaderLeft>
          <Skeleton width="120px" height="16px" className="mb-1" />
          <Skeleton width="180px" height="24px" />
        </HeaderLeft>
        <CarPreview>
          <div className="flex flex-col">
            <Skeleton width="120px" height="20px" className="mb-1" />
            <Skeleton width="100px" height="16px" />
          </div>
          <Skeleton width="64px" height="64px" borderRadius="4px" />
        </CarPreview>
      </Header>

      <TripSection>
        <SectionSkeleton />

        <TripDates>
          <DateBlock>
            <Skeleton width="100px" height="20px" className="mb-1" />
            <Skeleton width="80px" height="16px" />
          </DateBlock>

          <ArrowSkeleton />

          <DateBlock>
            <Skeleton width="100px" height="20px" className="mb-1" />
            <Skeleton width="80px" height="16px" />
          </DateBlock>
        </TripDates>

        <ButtonContainer>
          <Skeleton width="100%" height="40px" className="mb-2" />
          <Skeleton width="100%" height="40px" />
        </ButtonContainer>

        <LocationSection>
          <SectionSkeleton />
          <Skeleton width="80%" height="20px" className="mb-1" />
          <Skeleton width="120px" height="16px" />
        </LocationSection>

        <InfoSection>
          <SectionSkeleton />
          <InfoTextSkeleton />
          <SubTextSkeleton />
        </InfoSection>

        <InfoSection>
          <SectionSkeleton />
          <InfoTextSkeleton />
          <Skeleton width="140px" height="16px" />
        </InfoSection>
      </TripSection>

      <Skeleton width="120px" height="16px" className="mb-2" />
      <Skeleton width="180px" height="20px" className="mb-6" />

      <Skeleton width="100%" height="120px" className="mb-6" />
      <Skeleton width="100%" height="40px" className="mb-4" />
      <Skeleton width="160px" height="20px" />
    </Container>
  );
};

export default BookingDetailsSkeleton;
